import { render, staticRenderFns } from "./contact-details.vue?vue&type=template&id=18f53823&scoped=true&"
import script from "./contact-details.vue?vue&type=script&lang=js&"
export * from "./contact-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f53823",
  null
  
)

export default component.exports